import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tab.scss';

class Tab extends React.Component {
  render() {
    let {
      title,
      onSelected,
      isSelected
    } = this.props;
    return (
      <span
        onClick={!isSelected ? onSelected : undefined}
        className={classnames(isSelected ? styles.selected : styles.notSelected, styles.tab)}
      >
        {title}
      </span>
    );
  }
}

Tab.propTypes = {
  title: PropTypes.string,
  onSelected: PropTypes.func,
  isSelected: PropTypes.bool
};

export default Tab;